module.exports = __webpack_public_path__ + "static/media/alert.be18bd44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/alert.svg
// module id = 483
// module chunks = 0